"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mcpServerFilterMap = exports.mcpServerSortMap = exports.McpConnectionStatus = exports.McpAuthType = exports.McpTransportType = void 0;
var McpTransportType;
(function (McpTransportType) {
    McpTransportType["HttpStreamable"] = "http-streamable";
    McpTransportType["SSE"] = "sse";
    McpTransportType["WebSocket"] = "websocket";
})(McpTransportType || (exports.McpTransportType = McpTransportType = {}));
var McpAuthType;
(function (McpAuthType) {
    McpAuthType["Static"] = "static";
    McpAuthType["OAuthClientCredentials"] = "oauth_client_credentials";
    McpAuthType["OAuthAuthorizationCode"] = "oauth_authorization_code";
})(McpAuthType || (exports.McpAuthType = McpAuthType = {}));
var McpConnectionStatus;
(function (McpConnectionStatus) {
    McpConnectionStatus["Connected"] = "connected";
    McpConnectionStatus["Disconnected"] = "disconnected";
    McpConnectionStatus["Error"] = "error";
})(McpConnectionStatus || (exports.McpConnectionStatus = McpConnectionStatus = {}));
exports.mcpServerSortMap = {
    name: "mcs.name",
    transportType: "mcs.transport_type",
    authType: "mcs.auth_type",
    isEnabled: "mcs.is_enabled",
    connectionStatus: "mcs.connection_status",
    createdAt: "mcs.date_created",
    updatedAt: "mcs.date_modified",
};
exports.mcpServerFilterMap = {
    name: "mcs.name",
    transportType: "mcs.transport_type",
    authType: "mcs.auth_type",
    isEnabled: "mcs.is_enabled",
    connectionStatus: "mcs.connection_status",
};
